<modal-header>
    <h4>{{ 'Edit' | translate }}</h4>
    <save-and-cancel-buttons (save)="save(form)" [canSave]="canSave(form)"></save-and-cancel-buttons>
</modal-header>

<form #form="ngForm">
    <div class="modal-body form-horizontal d-flex flex-column">
        <dl *ngIf="!!translation">
            <dt>{{'Translation_key'|translate}}</dt>
            <dd>{{translation!.key}}</dd>

            <dt>{{referenceLanguage?.label??""|translate}}</dt>
            <dd *ngIf="translation!.isReferenceTranslated">{{translation.referenceText}}</dd>
            <dd *ngIf="!translation!.isReferenceTranslated">
                <span class="input-group">
                    <input type="text" class="form-control input-sm" [(ngModel)]="translation!.referenceText" name="referenceText" (ngModelChange)="referenceTextChanged()">
                    <button class="btn btn-outline-secondary" (click)="suggestReferenceText()"><i class="fa fa-magic-wand-sparkles"></i></button>
                </span>
                <label class="small text-muted" *ngIf="unchangedTranslation?.referenceText != translation!.referenceText" >{{'Original_text'|translate}}:&nbsp;{{unchangedTranslation?.referenceText}}</label>
            </dd>
            <dt>{{translationLanguage?.label??""|translate}}</dt>
            <dd>
                <span class="input-group">
                    <input type="text" class="form-control input-sm" [(ngModel)]="translation!.translationText" name="translationText" (ngModelChange)="translationTextChanged()">
                    <button class="btn btn-outline-secondary" (click)="suggestTranslationText()"><i class="fa fa-magic-wand-sparkles"></i></button>
                </span>
                <label class="small text-muted" *ngIf="unchangedTranslation?.translationText != translation!.translationText" >{{'Original_text'|translate}}:&nbsp;{{unchangedTranslation?.translationText}}</label>
            </dd>
        </dl>

        <h5 *ngIf="translations.length > 0" class="mt-4">{{'TranslatedLanguages'|translate}}</h5>

        <dl *ngFor="let translation of translations" class="culture-translations">
            <dt>{{translation.cultureCode}}</dt>
            <dd>{{translation.translationText}}</dd>
        </dl>
    </div>
</form>
